import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Api from "utils/wApi/index";
import useCart from "store";

import Header from "layout/header/index";
import { Box, Stack, Container, Button, Typography } from "@mui/material";
import { SvgIconStyle, Cart, CartSlider } from "components";
import { BottomButtons } from "components/unitComponent";

import CardIcon from "assets/icons/card.svg";
import BackIcon from "assets/icons/back.svg";
import AdMenu from "components/ad/ad-menu";
// ----------------------------------------------------------------------

export default function Layout({ children, noCategory }) {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();
	const {
		language,
		cart,
		total,
		removeAllCart,
		removeCart,
		callCart,
		category,
		active,
		setActive,
	} = useCart((state) => state);

	useEffect(() => {
		callCart();
	}, []);

	return (
		<>
			<Box
				bgcolor="grey.100"
				sx={{
					height: "100vh",
					minHeight: "100vh",
					maxHeight: "100vh",
					maxWidth: "100vw",
					overflow: "hidden",
				}}
			>
				<Container
					sx={{
						backgroundColor: "white",
						height: "100%",
						px: `0 !important`,
						display: "flex",
						flexDirection: "column",
						overflow: "hidden",
					}}
				>
					<Header />

					<Box
						sx={{
							flexGrow: 1,
							minHeight: 0,
							overflowY: "scroll",
							overflowX: "hidden",
							"&:-webkit-scrollbar": { display: "none" },
						}}
					>
						{children}
					</Box>

					{/* footer */}
					<Box sx={{ width: "100%", position: "relative", flexShrink: 0 }}>
						<CartSlider
							language={language}
							cart={cart}
							t={t}
							total={total}
							onDelete={(item) => removeCart(item)}
							onDeleteAll={() => removeAllCart()}
						/>

						{/* bottom buttons*/}
						{location.pathname === "/" ? (
							<Button
								fullWidth
								variant="contained"
								color="primary"
								onClick={() => navigate("/order", { state: { history: true } })}
								disabled={!cart.length}
								sx={{
									borderRadius: 0,
									height: 80,
									display: "flex",
									alignItems: "center",
								}}
							>
								<SvgIconStyle src={CardIcon} size={32} sx={{ mr: 1 }} />
								<Typography variant="h2">
									{cart.length > 0
										? `${t("count", {
												count: cart.reduce(
													(acc, item) => acc + item.buyCount,
													0
												),
										  })}(${t("price", {
												price: total.toLocaleString(),
										  })}) ${t("pay")}`
										: t("pay")}
								</Typography>
							</Button>
						) : (
							<BottomButtons
								left={
									location.pathname === "/"
										? ""
										: {
												label: t("back"),
												onClick: () => {
													const [type, ...query] = location.pathname
														.split("/")
														.filter((v) => v !== "");
													if (type === "menus") navigate("/");
													if (type === "detail") navigate("/menus");
												},
												// navigate(-1),
										  }
								}
								right={{
									label: t("pay"),
									onClick: () =>
										navigate("/order", { state: { history: true } }),
									icon: CardIcon,
									disabled: !cart.length,
								}}
							/>
						)}
					</Box>
				</Container>
			</Box>
		</>
	);
}
